import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ProductService } from 'src/app/service/product.service';
import { Category, Product, Talle } from 'src/app/types/types';
import { AngularFireStorage } from '@angular/fire/storage';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-edit-product-modal',
  templateUrl: './edit-product-modal.component.html',
  styleUrls: ['./edit-product-modal.component.css']
})
export class EditProductModalComponent implements OnInit {
  @Output("update") 
  update = new EventEmitter();  
  @Input("product")
  product: Product;
  talles : Talle[] = [];
  categories : Category[] = [];
  form : FormGroup;
  path:string;
  imageUploaded :boolean;
  constructor(
    private productService : ProductService,
    private af : AngularFireStorage,
    private fb : FormBuilder,
    private modalService: NgbModal
  ) {
    this.imageUploaded=false;
    this.path = '';
    this.talles = this.productService.getTalles();
    this.categories = this.productService.getCategories();
   }

   open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size:"xl"})
  }

   initForm() {
    this.form = this.fb.group({
      name:        new FormControl(this.product.name ,[Validators.required]),
      description: new FormControl(this.product.description,[Validators.required]),
      imgUrl:      new FormControl(this.product.imgUrl,[]),
      price:       new FormControl(this.product.price,[Validators.required,Validators.min(1)]),
      discount:    new FormControl(this.product.discount,[]),
      category:    new FormControl(this.product.category,[Validators.required]),
      isVisible :  new FormControl(this.product.visible,[]),
      isTrending : new FormControl(this.product.isTrending,[])
    })
    this.talles.forEach( t => {
        this.form.addControl(t,new FormControl(this.product.talles[t]))
      });
   }

   putForm(){
    const bodyTalles = this.talles.filter( t => this.form.get(t).value);
     const body : Product = {
       _id : this.product._id,
       name:this.form.get('name').value,
       description:this.form.get('description').value,
       imgUrl:this.form.get('imgUrl').value,
       price:parseFloat(this.form.get('price').value),
       discount:this.form.get('discount').value,
       talles : bodyTalles,
       category:this.form.get('category').value,
       visible:this.form.get('isVisible').value,
       date:this.product.date,
       isTrending: this.form.get('isTrending').value
     }
     if(this.form.invalid || this.invalidTalles || this.invalidImage ){
        console.log("invalid",this.form)
     }
     else{
      this.productService.update(body).subscribe(() => {
        Swal.fire({
          title:"Actualizado!",
          icon:"success"
        }).then( () => this.modalService.dismissAll);
       });
     }
   }

  ngOnInit(): void {
    this.initForm();
  }

  upload($event) {
    this.path = $event.target.files[0];
  }

  getNameForFile() {
    return this.form.get('name').value + Math.random();
  }

  uploadImage() {
    console.log(this.path)
  this.af.upload(this.getNameForFile(),this.path).then( res => {this.setImageUrl(this.getNameForFile());console.log(res)});
  }

  getUrlOfName(name:string) {
    return `https://firebasestorage.googleapis.com/v0/b/pomelo-bebes.appspot.com/o/${name}?alt=media`
  }

  setImageUrl(name : string) {
    this.form.get('imgUrl').setValue(this.getUrlOfName(name))
  }

  get invalidImage() {
    return this.path === '' && this.form.get('imgUrl').value === ''
  }

  get invalidName() {
    return this.form.get('name').invalid && this.form.get('name').touched;
  }
  get invalidDescription() {
    return this.form.get('description').invalid && this.form.get('description').touched;
  }
  get invalidPrice() {
    return this.form.get('price').invalid && this.form.get('price').touched;
  }
  get invalidDiscount() {
    return this.form.get('discount').invalid && this.form.get('discount').touched;
  }
  get invalidImgUrl() {
    return this.form.get('imgUrl').invalid && this.form.get('imgUrl').touched && !this.path;
  }
  get invalidCategory() {
    return this.form.get('category').invalid && this.form.get('category').touched;
  }
  get invalidTalles() {
    return this.talles.every( t => ! this.form.get(t).value);
  }
}
